import { isInViewport } from '@/utils/viewport/isInViewport';

export const scrollIntoView = (el: Element) => {
  if (!isInViewport(el)) {
    el.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });
  }
};
